import {SET_IS_DELETED_PROFILE, SET_IS_PASSWORD_RESETED, SET_PROFILE, SET_USER} from "./user-types";


const initialState = {
  user: null,
  profile: null,
  isPasswordReseted: false,
  isDeletedProfile: false
}

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER: return {...state, user: action.user}
    case SET_PROFILE: return {...state, profile: action.profile}
    case SET_IS_PASSWORD_RESETED: return {...state, isPasswordReseted: action.isPasswordReseted}
    case SET_IS_DELETED_PROFILE: return {...state, isDeletedProfile: action.isDeletedProfile}
    default: return state
  }
}
